import validator from 'validator';
import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: string): boolean {
  return value === '';
}

/** URL custom field, stored in `string_value` (legacy `URL.jsx`). */
export const urlCodec: FieldCodec<'url'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    return row?.string_value ?? '';
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({ string_value: value })
    };
  },
  empty() {
    return '';
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value =>
      !isEmpty(value) && !validator.isURL(value)
        ? validation.invalid({ code: 'invalid-url' })
        : validation.valid()
    );
  }
};
